import React from 'react';
import { Users, HeartHandshake, Landmark, Trees, Trophy, Megaphone } from 'lucide-react';
import SectionDirectory from '../components/SectionDirectory';

const GROUPS = [
  {
    name: 'Get involved',
    icon: <Users size={17} />,
    blurb: 'Volunteering, community groups and having your say.',
    links: [
      { name: 'Engage Renfrewshire', url: 'https://www.engagerenfrewshire.com', note: 'The local hub for charities, volunteering and community groups' },
      { name: 'Volunteer Renfrewshire', url: 'https://www.volunteerrenfrewshire.org', note: 'Find a volunteering role near you' },
      { name: 'Community councils', url: 'https://www.renfrewshire.gov.uk/community-councils', note: 'Your area\'s elected community voice' },
      { name: 'Submit a community event', url: '/events/submit', internal: true, note: 'Free listings for local groups' },
    ],
  },
  {
    name: 'Help & support',
    icon: <HeartHandshake size={17} />,
    blurb: 'Practical help when things are difficult.',
    links: [
      { name: 'Citizens Advice Scotland', url: 'https://www.cas.org.uk', note: 'Free, confidential advice on money, work and housing' },
      { name: 'Renfrewshire Council — money advice', url: 'https://www.renfrewshire.gov.uk/advice', note: 'Benefits, crisis grants and welfare support' },
      { name: 'Find a food bank', url: 'https://www.trusselltrust.org/get-help/find-a-foodbank/', note: 'Trussell Trust referral finder' },
      { name: 'Breathing Space Scotland', url: 'https://breathingspace.scot', note: 'Free mental health listening service — 0800 83 85 87' },
    ],
  },
  {
    name: 'Culture & heritage',
    icon: <Landmark size={17} />,
    blurb: 'The institutions that keep Paisley\'s story going.',
    links: [
      { name: 'Paisley Museum', url: 'https://paisleymuseum.org', note: 'Reimagined and reopened for the town' },
      { name: 'Renfrewshire Leisure', url: 'https://www.renfrewshireleisure.com', note: 'Libraries, halls, venues and sport' },
      { name: 'Paisley Abbey', url: 'https://paisleyabbey.org.uk', note: 'Twelfth-century abbey, still an active church' },
      { name: 'Paisley history on paisley.org.uk', url: '/history', internal: true },
      { name: 'Famous people from Paisley', url: '/famous-people', internal: true },
    ],
  },
  {
    name: 'Parks & outdoors',
    icon: <Trees size={17} />,
    links: [
      { name: 'Renfrewshire parks & open spaces', url: 'https://www.renfrewshire.gov.uk/parks', note: 'Barshaw, Robertson, Gleniffer Braes and more' },
      { name: 'Clyde Muirshiel Regional Park', url: 'https://www.clydemuirshiel.co.uk', note: 'Hills, lochs and trails on the doorstep' },
      { name: 'Visitor attractions', url: '/attractions', internal: true },
    ],
  },
  {
    name: 'Sport',
    icon: <Trophy size={17} />,
    links: [
      { name: 'St Mirren FC coverage', url: '/st-mirren', internal: true, note: 'Live scores, fixtures and stats' },
      { name: 'St Mirren FC official site', url: 'https://stmirren.com' },
      { name: 'Renfrewshire Leisure sport & fitness', url: 'https://www.renfrewshireleisure.com' },
    ],
  },
  {
    name: 'Tell us something',
    icon: <Megaphone size={17} />,
    blurb: 'We are an independent community site — tips are always welcome.',
    links: [
      { name: 'Contact the newsroom', url: '/contact', internal: true },
      { name: 'Paisley business directory', url: 'https://paisleyscotland.com/directory', note: 'Listings on our sister site' },
    ],
  },
];

const CommunityPage = () => (
  <SectionDirectory
    kicker="Paisley & Renfrewshire"
    title="Community"
    intro="Volunteering, local groups, support services, culture and the outdoors — the organisations that make Paisley work."
    seo={{
      title: 'Community in Paisley & Renfrewshire — groups, volunteering and support',
      description: 'Volunteering, community councils, money and mental health support, culture, parks and sport across Paisley and Renfrewshire.',
      url: '/community',
    }}
    groups={GROUPS}
    footnote="These are independent organisations and we are not affiliated with them. If a link is out of date or your group should be listed here, please get in touch."
  />
);

export default CommunityPage;
